var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    ref: "scroll-win-ref",
    staticClass: "ai-chat-wrapper",
    style: {
      height: _vm.height
    },
    on: {
      touchmove: _vm.wheelEvent,
      wheel: _vm.wheelEvent
    }
  }, [_c("ai-win", {
    on: {
      send: _vm.sendMessage
    }
  }), _c("div", {
    staticClass: "ai-input"
  }, [_c("ai-input", {
    attrs: {
      "use-speech": !!_vm.userInfo.id,
      "show-carton": false
    },
    on: {
      send: _vm.sendMessage,
      stop: _vm.handleStop
    }
  }), _c("div", {
    staticClass: "ai-desc"
  }, [_vm._v("内容由AI生成")])], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOverlay,
      expression: "showOverlay"
    }]
  }, [_c("van-overlay", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("van-loading", {
    attrs: {
      size: "24px",
      vertical: ""
    }
  }, [_vm._v("加载中...")])], 1)])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };